import React, { FC } from 'react';
import { BlindCompanyDto } from '@domain/rs/profile/blind/BlindCompanyListRs';

import classnames from 'classnames/bind';
import styles from './blindCompanyListModal.module.scss';
const cx = classnames.bind(styles);

interface IChipCardProps {
  title: string;
  onDelete: () => void;
}

const ChipCard: FC<IChipCardProps> = ({ title, onDelete }) => {
  return (
    <li className={cx('listItem')}>
      {title}
      <a className={cx('btnDelete')} role="button" onClick={onDelete} />
    </li>
  );
};

interface IChipListProps {
  blindCompanies?: BlindCompanyDto[];
  onDeleteBlindCompany: (sn: number) => void;
}

const ChipList: FC<IChipListProps> = ({ blindCompanies = [], onDeleteBlindCompany }) => {
  if (!blindCompanies.length) return null;

  const chipListEl = blindCompanies.map((item) => {
    return <ChipCard key={item.sn} title={item.name} onDelete={() => onDeleteBlindCompany(item.sn)} />;
  });

  return <ul className={cx('selectList')}>{chipListEl}</ul>;
};

export default ChipList;
